'use client';

import { useParams } from 'next/navigation';
import { useRouter } from '@/i18n/navigation';
import { CategoryButton } from '@/components/server-category-tree/_components/server-category-tree-display/_components/category-button';
import {
  getMaterialRoute,
  getUrl,
  TMultiPageRouteParams,
} from '@/_constants/routes';
import { articleSectionClickEvent } from '@/_analytic/events/article-section-click-event';
import { useClientSearchParams } from '@/_hooks/use-client-search-params';
import {
  TMaterialsTreeArticleItem,
  TMaterialsTreeCategoryItem,
} from '@/api/get-materials-tree/_types';

type TProps = {
  material: TMaterialsTreeArticleItem;
  category: TMaterialsTreeCategoryItem;
  parentCategoryTitle: string;
};

export const ClientMaterialLinkButton = ({
  material,
  category,
  parentCategoryTitle,
}: TProps) => {
  const router = useRouter();
  const searchParams = useClientSearchParams();
  const { country, materialId } = useParams<TMultiPageRouteParams>();
  const categoryName = category.title;

  const handleMaterialClick = () => {
    articleSectionClickEvent({
      sectionName: parentCategoryTitle,
      subsectionName: categoryName,
      idArticle: material.id,
      articleName: material.title,
      sectionId: category.parentId,
      subsectionId: category.id,
      isSidebar: true,
    });

    router.push(
      getUrl({
        route: getMaterialRoute({
          materialId: material.id,
          materialSlug: material.slug,
          country,
        }),
        searchParams: {
          ...searchParams,
          categoryId: category.slug || category.id,
        },
      }),
    );
  };
  const isActiveMaterial =
    material.slug === materialId || material.id === materialId;

  return (
    <CategoryButton
      key={material.id}
      id={material.slug || material.id}
      isActive={isActiveMaterial}
      isArticle
      isAvailable
      onClick={handleMaterialClick}
      text={material.title}
    />
  );
};
